import { useToast } from "contexts/ToastContext";
import { useState } from "react";
import { updateLegislativeDrafting } from "services/legislativeService";
import ShowUI, { CanShow, LEGISLATIVE_DRAFTING_UI_RULES } from "utils/authRules";
import { LoadingIcon } from "utils/constant";
import { LAW_IMPLEMENTATION_REQUEST_STATUS, LEGISLATIVE_DRAFTING_REQUEST_STATUS } from "utils/constantValues";
import UploadDraftLaw from "./uploadDraftLaw";
import UploadResearchData from "./uploadRequestForAdditionalInfo";
import { useTranslation } from "react-i18next";

export default function ProsecutorRemark({ setFormState, formState }: { setFormState: any, formState: any }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isTargetModalOpen, setIsTargetModalOpen] = useState(false);
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
    const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);

    const handleCloseModal = () => {
        setIsModalOpen(false);
    }
    const handleFeedbackCloseModal = () => {
        setIsFeedbackModalOpen(false);
    }
    const handleTargetCloseModal = () => {
        setIsTargetModalOpen(false);
    }
    const handleRequestCloseModal = () => {
        setIsRequestModalOpen(false);
    }

    const handleReject = () => {
    }

    const handleUploadProposalClick = () => {
    }

    return (
        <>
            <div className="mt-4 flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4">
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.upload_audit_target.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <button
                        type="button"
                        className="ml-auto px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300 disabled:opacity-50"
                        onClick={() => setIsTargetModalOpen(true)}
                        disabled={loading}
                    >
                        {loading ? (
                            <div className="flex items-center justify-center">
                                {LoadingIcon} {t("Submitting") || "Submitting..."}
                            </div>
                        ) : (
                            t("UploadAuditTarget") || "Upload Audit Target"
                        )}
                    </button>
                </ShowUI>
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.upload_audit.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <button
                        type="button"
                        onClick={() => !loading && setIsModalOpen(true)}
                        disabled={loading}
                        className="inline-flex flex-1 items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#0A1D39] text-white text-sm font-semibold shadow-sm hover:bg-[#13294d] focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/40 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? (
                            <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                        ) : (
                            <>
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                {t("InsertEvidence") || "Insert Evidence"}
                            </>
                        )}
                    </button>
                </ShowUI>
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.team_appointed.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <button
                        type="button"
                        onClick={() => !loading && setIsRequestModalOpen(true)}
                        disabled={loading}
                        className="inline-flex flex-1 items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#0A1D39] text-white text-sm font-semibold shadow-sm hover:bg-[#13294d] focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/40 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? (
                            <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                        ) : (
                            <>
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                {t("InsertEnforcementAnalysis") || "Insert Enforcement Analysis"}
                            </>
                        )}
                    </button>
                </ShowUI>
                {formState.audit_evidences &&
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.upload_audit.value}
                        currentStatus={formState.current_approval_status}
                        forwardStatus={formState.forward_status}
                    >
                        <button
                            type="button"
                            onClick={() => !loading && setIsFeedbackModalOpen(true)}
                            disabled={loading}
                            className="inline-flex flex-1 items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#9B0505] text-white text-sm font-semibold shadow-sm hover:bg-[#7e0404] focus:outline-none focus:ring-2 focus:ring-[#9B0505]/40 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {loading ? (
                                <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                            ) : (
                                <>
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    {t("Audit") || "Audit"}
                                </>
                            )}
                        </button>
                    </ShowUI>
                }
            </div>
            <UploadDraftLaw
                request={formState}
                setLegalResearch={setFormState}
                isOpen={isTargetModalOpen}
                onClose={handleTargetCloseModal}
                onUploadProposal={handleUploadProposalClick}
                type="target"
            />
            <UploadDraftLaw
                request={formState}
                setLegalResearch={setFormState}
                isOpen={isFeedbackModalOpen}
                onClose={handleFeedbackCloseModal}
                onUploadProposal={handleUploadProposalClick}
                type="legal"
            />
            <UploadDraftLaw
                request={formState}
                setLegalResearch={setFormState}
                isOpen={isRequestModalOpen}
                onClose={handleRequestCloseModal}
                onUploadProposal={handleUploadProposalClick}
            />
            <UploadResearchData
                request={formState}
                setLegalResearch={setFormState}
                isOpen={isModalOpen}
                onClose={handleCloseModal}
            />
        </>
    );
}